import { CouponCodeFailError, SaleOrder } from "@tendercuts/models";
import { PosQuote } from "../../models";
import { GenericError } from "@tendercuts/models";

export interface CartState {
  quote: PosQuote;
  loading: boolean;
  errorMsg: GenericError | CouponCodeFailError;
  error: Boolean;
  couponCode: string;
  couponCodeMessage: string;
  couponCodeError: boolean;
  saleOrder: SaleOrder;
  rewardsEarned: number;
}

export const cartInitialState: CartState = {
  quote: new PosQuote(),
  loading: false,
  errorMsg: null,
  error: false,
  couponCode: null,
  couponCodeMessage: null,
  couponCodeError: false,
  saleOrder: null,
  rewardsEarned: null,
};

export function cartTestState(): CartState {
  return {
    quote: new PosQuote(),
    loading: false,
    errorMsg: null,
    error: false,
    couponCode: null,
    couponCodeMessage: null,
    couponCodeError: false,
    saleOrder: null,
    rewardsEarned: null,
  };
}
